<template>
  <div class="preview">
    <div class="top">
      <div>
        <van-button icon="arrow-left" size="small" @click="back" color="#006EFF"/>
      </div>
    </div>
    <div style="display: flex;justify-content: center">
      <div id="canvas" class="canvas">
        <div id="image" :style="{
          backgroundImage: `url(${backUrl})`,
          backgroundSize: '100% 100%'
        }">
          <vdr :h="parseFloat(items.infoHeight) / zoom" :w="parseFloat(items.infoWidth) / zoom"
               :y="parseFloat(items.infoY) / zoom" :draggable="false" :resizable="false"
               :x="parseFloat(items.infoX) / zoom" :index="index"
               v-for="(items,index) in componentsList" :key="index">
            <div class="resizable-content" v-if="items.coType === 'img'">
              <img :src="upFileUrl + item.url" class="img-content"
                   v-for="(item,index) in items.mpList"
                   :key="index"/>
            </div>
            <div class="resizable-content" v-else-if="items.coType === 'subtitle'" v-for="(item,index) in items.txList"
                 :key="index"
                 :style="{'backgroundColor':item.taBgColor,'color':item.taColor,'fontSize':item.taFontSize + 'px'}">
              <div class="text-content">{{item.taContent}}</div>
            </div>
            <div class="resizable-content" v-else-if="items.coType === 'video'">
              <img :src="upFileUrl + item.viewUrl" style="width: 100%;height: 100%;"
                   @error="errImg(item)"
                   v-for="(item,index) in items.mpList"
                   :key="index"/>
            </div>
            <div class="resizable-content" v-else-if="items.coType === 'streaming'" v-for="(item,index) in items.txList"
                 :key="index"
                 :style="{'backgroundColor':item.taBgColor,'color':item.taColor,'fontSize':item.taFontSize + 'px'}">
              <div class="text-content">
                <img src="/static/images/liumeiti.jpg" style="width: 100%;height: 100%;"
                     v-if="item.taContent !== ''"/>
              </div>
            </div>
            <div class="resizable-content" v-else-if="items.coType === 'webPage'" v-for="(item,index) in items.txList"
                 :key="index"
                 :style="{'backgroundColor':item.taBgColor,'color':item.taColor,'fontSize':item.taFontSize + 'px'}">
              <div class="text-content">
                <img src="/static/images/web.jpg" v-if="item.taContent !== ''"/>
              </div>
            </div>
          </vdr>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import vdr from '../components/vue-draggable-resizable'
  import qs from 'qs'
  import {mapActions, mapState} from 'vuex'

  export default {
    name: 'preview',
    data() {
      return {
        pmId: this.$route.query.id,
        mainResolutionW: 0,
        mainResolutionH: 0,
        zoom: 1,
        imgsetting: false,
        videosetting: false,
        subtitlesetting: false,
        websetting: false,
        isImgList: false,
        isVideoList: false,
        isText: false,
        isBack: false,
      }
    },
    mounted() {
      this.width = document.getElementById('canvas').offsetWidth
      this.$nextTick(() => {
        document.getElementById('canvas').style.height = `${this.width}px`
      })

      this.$ajax.post('/etv/selectPhoneProgramMould.json', qs.stringify({
        pmId: this.pmId,
      })).then(res => {
        if (res.data.code === 0) {
          document.title = this.$t('append_field.preview')
          const resolution = res.data.data.pmResolution
          this.mainResolutionW = parseInt(resolution.split('*')[0])
          this.mainResolutionH = parseInt(resolution.split('*')[1])
          this.getZoom()
          this.$store.state.componentsList = res.data.data.sceneList[0].componentsList
          this.$store.state.backUrl = this.upFileUrl + res.data.data.sceneList[0].scBackImg
          this.$store.state.sceneList = res.data.data.sceneList[0]
          this.componentsList.map(res => {
            res.infoX = res.coLeftPosition
            res.infoY = res.coRightPosition
            res.infoWidth = res.coWidth
            res.infoHeight = res.coHeight
          })

        }
      })
    },
    methods: {
      ...mapActions(['addControl', 'addSubtitle', 'submit', 'emptyCanvns', 'addBackground']),
      getZoom() {
        if (this.mainResolutionW / this.mainResolutionH > 1) {
          this.zoom = this.mainResolutionW / this.width
          document.getElementById('image').style.height = this.mainResolutionH / this.zoom + 'px'
        } else {
          document.getElementById('image').style.height = '100%'
          this.zoom = this.mainResolutionH / this.width
          document.getElementById('image').style.width = this.mainResolutionW / this.zoom + 'px'
        }
      },
      back() {
        this.$router.back()
      }
    },
    computed: {
      ...mapState({
        controlIndex: state => state.controlIndex,
        componentsList: state => state.componentsList,
        backUrl: state => state.backUrl,
      }),
    },
    components: {
      vdr,
    },
  }
</script>

<style scoped lang="scss">
  .preview {
    height: 100%;

    .vdr {
      border: none !important;

    }

    .van-button--small {
      min-width: 10px !important;
    }

    .top {
      padding: 15px;
      display: flex;
      justify-content: space-between;
    }

    .canvas {
      width: calc(100% - 10px);
      margin: 20px auto;
      height: 200px;
      display: flex;
      justify-content: center;
      box-sizing: border-box;
    }

    #image {
      background: #ffffff;
      position: relative;
      width: 100%;
    }

    .resizable-content {
      overflow: hidden;
      width: 100%;
      height: 100%;

      .img-content {
        width: 100%;
        height: 100%;
      }

      .text-content {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

    }
  }
</style>
